import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate.js"; // Import your configured axios instance
import "./UsersList.css"; // Import the CSS file
import { formatDate } from "../../utils/Utilities.js";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";


const ListManifestOutScanByDate = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/ManifestOutScan");
  }
  const [ListManifestOutScanByDate, setListManifestOutScanByDate] = useState([]); // To store list of ListManifestOutScanByDate
  const [loading, setLoading] = useState(false); // Set loading initially to false
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [fromDate, setFromDate] = useState(""); // To store the from_date value
  const [toDate, setToDate] = useState(""); // To store the to_date value
  const ListManifestOutScanByDatePerPage = 10; // Number of ListManifestOutScanByDate per page
  const axiosPrivate = useAxiosPrivate();
  const LIST_MANIFEST_OUT_SCAN_URL = "api/list-manifest-outscan"; // Replace with the correct API endpoint to fetch ListManifestOutScanByDate
  const { auth } = useAuth();


  // Fetch ListManifestOutScanByDate based on from_date and to_date
  const fetchListManifestOutScanByDate = async (fromDate, toDate) => {
    setLoading(true); // Start loading spinner
    try {
      const fromDate_Formated = formatDate(fromDate);
      const toDate_Formated = formatDate(toDate);
      const data = {
        franchise_id: auth.franchise_id,
        from_date: fromDate_Formated,
        to_date: toDate_Formated,
      };

      const response = await axiosPrivate.get(LIST_MANIFEST_OUT_SCAN_URL, {
        params: data,
      });

      setListManifestOutScanByDate(response.data); // Store the list of ListManifestOutScanByDate into the state
      setLoading(false); // Stop loading spinner
      setError(null); // Clear any previous error
    } catch (error) {
      console.error("Error fetching Bookings Consignments:", error);
      setError("Failed to load Booking Consignments");
      setLoading(false); // Set loading to false even if there is an error
    }
  };

  // Handle the search button click to fetch data with the new dates
  const handleSearch = () => {
    if (fromDate && toDate) {
      fetchListManifestOutScanByDate(fromDate, toDate);
      setError(null); // Clear the error if dates are valid
    } else {
      setError("Please enter both from and to dates."); // Show error if dates are missing
    }
  };

  // Paginate ListManifestOutScanByDate
  const indexOfLastListManifestOutScanByDate = currentPage * ListManifestOutScanByDatePerPage;
  const indexOfFirstListManifestOutScanByDate = indexOfLastListManifestOutScanByDate - ListManifestOutScanByDatePerPage;
  const currentListManifestOutScanByDate = ListManifestOutScanByDate.slice(indexOfFirstListManifestOutScanByDate, indexOfLastListManifestOutScanByDate);

  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(ListManifestOutScanByDate.length / ListManifestOutScanByDatePerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>


      <section className="newsections">


        <div className="newwrap">
          <div className="d-flex align-items-center">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <div className="ms-auto">
              <button onClick={handleRedirect} type="button" className="btn btn-success top-bt">
                Manifest OutScan
              </button>
            </div>
          </div>
          <h3> Manifest OutScan List</h3>

          {/* Date Filters and Search Button */}
          <center><div className="search-filters newfilter">
            <label htmlFor="fromDate">From Date:</label>
            <input
              type="date"
              id="fromDate"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <label htmlFor="toDate">To Date:</label>
            <input
              type="date"
              id="toDate"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
            <br />
            <button onClick={handleSearch} className="btn scanbutton">Search</button>
          </div>
          </center>

          {/* Show error message if both dates are not provided */}
          {error && (
            <div className="error-message">
              <div className="error">{error}</div>
              {/* Show the search filters again below the error */}
            </div>
          )}

          {/* Show the table for displaying ListManifestOutScanByDate only when there are results */}
          {ListManifestOutScanByDate.length > 0 && !error && (
            <>
              <table border="1" id="customers">
                <thead>
                  <tr>
                    <th>Manifest number</th>
                    <th>Manifest date</th>
                    <th>Destination franchise</th>
                    <th>Total cons.</th>
                    <th>Weight</th>
                    <th>Scan Time</th>
                    <th>status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentListManifestOutScanByDate.map((ListManifestOutScanByDate) => (
                    <tr key={ListManifestOutScanByDate.manifest_number}>
                      <td>{ListManifestOutScanByDate.manifest_number}</td>
                      <td>{ListManifestOutScanByDate.manifest_date}</td>
                      <td>{ListManifestOutScanByDate.manifest_destination_franchise_name} - {ListManifestOutScanByDate.manifest_destination_franchise_code}</td>
                      <td>{ListManifestOutScanByDate.total_consignments}</td>
                      <td>{ListManifestOutScanByDate.weight}</td>
                      <td>{ListManifestOutScanByDate.scan_time}</td>
                      <td>{ListManifestOutScanByDate.current_status}</td>

                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination - only show if there are multiple pages */}
              {totalPages > 1 && (
                <div className="pagination">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      disabled={currentPage === index + 1}>
                      {index + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}

          {/* If no ListManifestOutScanByDate and error isn't shown, display a "No results" message */}
          {ListManifestOutScanByDate.length === 0 && !loading && !error && (
            <div className="no-results">
              <p>No Booking Consignments found for the selected date range.</p>
            </div>
          )}
        </div>
      </section>
      <TopBar />
    </>
  );
};

export default ListManifestOutScanByDate;
